import { useNavigate } from "react-router-dom";

export default function FestivalPage() {
  
    const navigate = useNavigate()
  
    return (
      <div className="flex flex-col items-center justify-center p-6 text-center bg-white">
        <h1 className="text-3xl   text-[#5C000D] uppercase md:text-5xl">
          Enjoy Your Time In The Festival
        </h1>
        <div className="w-16 h-1 my-4 "></div>
        <p className="max-w-2xl text-sm text-[#392968] font-semibold md:text-lg">
          Enjoy Your Time In the most amazing international performing-arts shows, exciting competitions, 
          popular events and breath-taking firework displays, and enjoy a wide variety of unforgettable 
          memorable celebrations.
        </p>
        <button onClick={()=>navigate('/payment')} className="px-6 py-2 mt-6 font-bold text-[#392968] bg-[#FFD367] rounded-full      ">
          Book Now
        </button>
      </div>
    );
  }
  